import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useAppSelector } from '../../hooks';

/**
 * Header — top navigation bar (80 px tall).
 * Mirrors the <header> in atss-manage-web/views/_base-layout.ejs.
 * Shows company name + separator + Porters logo on the right side.
 */
export const Header: React.FC = () => {
  const companyName = useAppSelector((s) => s.session.data?.companyName ?? '');

  return (
    <header className="navbar header">
      <div className="container-fluid">
        {/* Left side — reserved for page-specific breadcrumbs/controls */}
        <div className="d-flex align-items-center" />

        {/* Right side — company name, separator, Porters logo, info link */}
        <div className="header__right">
          {companyName && (
            <>
              <span className="header__company-name">{companyName}</span>
              <div className="header__separator" />
            </>
          )}
          <img src="/img/img_porters_logo_monotone.svg" className="header__logo" alt="Porters" />
          <a
            className="navbar-brand ms-auto d-flex align-items-center"
            href="https://hrbc-jp.porterscloud.com/common/navigation"
            target="_blank"
            rel="noreferrer"
          >
            <OpenInNewIcon className="icon--primary" />
          </a>
        </div>
      </div>
    </header>
  );
};
